import { createContext, useContext, useState, useEffect } from "react";
import useSWR from "swr";
import axios from "axios";
import { AuthUrls, CategoryApiUrls } from "../Api/Auth/ApiUrls";
import {
  logoutUser,
  noAuthfetcher,
  sendPostRequestAuth,
} from "../Api/swrConfig";
import useSWRMutation from "swr/mutation";
import useToastError from "../hooks/useErrorToast";
import { toast } from "react-toastify";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem("authToken") || null);
  const [userData, setUserData] = useState(null);
  const { showErrorToast } = useToastError();

  // Fetch profile data with SWR
  const fetcher = async (url) => {
    const token = localStorage.getItem("authToken");
    if (!token) throw new Error("No token");

    const apiUrl = process.env.REACT_APP_BASE_URL + url;
    try {
      const { data } = await axios.get(apiUrl, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (data?.userData) {
        setUserData(data.userData);
      }

      return data;
    } catch (error) {
      if (error.response && error.response.status === 403) {
        logoutUser();
      }
      throw error;
    }
  };

  const { data, error, isLoading, mutate } = useSWR(
    token ? AuthUrls.profile : null,
    fetcher
  );

  const {
    data: categoryData,
    mutate: categoryMutate,
    isLoading: categoryLoading,
  } = useSWR(CategoryApiUrls.listWithCourses, noAuthfetcher);

  const { trigger } = useSWRMutation(AuthUrls.logout, sendPostRequestAuth, {
    onSuccess: (data) => {
      toast.success("Logged Out Successesfully");
      setToken(null);
      setUserData(null);
      localStorage.removeItem("authToken");
    },
    onError: (error) => {
      console.log(error);
      showErrorToast(error);
      // console.log(error);
    },
  });

  const logout = () => {
    trigger();
  };

  useEffect(() => {
    if (data?.userData) {
      setUserData(data.userData);
    }
  }, [data]);

  return (
    <AuthContext.Provider
      value={{
        token,
        setToken,
        userData,
        setUserData,
        logout,
        loading: isLoading,
        error,
        mutate,
        categoryData: categoryData?.data,
        categoryMutate,
        categoryLoading,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
